import BookingSlotService from '@/services/BookingSlotService';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    bookingSlots: [],
  },
  mutations: {
    SET_BOOKING_SLOTS(state, item) {
      state.bookingSlots = item;
    }
  },
  actions: {
    getBookingSlots({commit}) {
      return BookingSlotService.getAllBookingSlots().then((res) => {
        commit('SET_BOOKING_SLOTS', res.data);
        return res.data;
      }).catch((err) => {
        Vue.$toast.error('Unable to get booking slots. Please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        return err;
      });
    }
  }
};
